import { _ as D } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.object.assign-7e79fd7b.js";
import { QUERIES as d, BREAKPOINTS as S } from "@ucl/shared-component-foundations";
import * as F from "react";
import $, { useContext as W, useState as P, useEffect as K } from "react";
import s, { styled as U, css as L } from "styled-components";
import { TableContext as k } from "./provider.js";
import { jsx as o, jsxs as j } from "react/jsx-runtime";
import "./es.string.small-23219181.js";
import { _ as N } from "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./es.array.every-3d11adb5.js";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.array.some-0c761b6d.js";
import "./es.object.to-string-f55666a8.js";
import "./es.object.keys-9d66766f.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import "./web.set-timeout-72b6430f.js";
import "./useScroll.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { useWindowSize as q } from "./useWindowSize.js";
import { a as v, C as O } from "./index-f5b44da3.js";
var Q = ["children", "marketingTable", "isColumnButtonEnabled"], X = /* @__PURE__ */ s.tbody.withConfig({
  displayName: "tBody__TBody",
  componentId: "ndobh2-0"
})(["@media ", "{}", " ", "}"], d.tabletAndUp, function(e) {
  if (e.$isstickycolumn)
    return e.$showcheckboxenabled ? `
      td:nth-child(2){
       &:before {
      content: ' ';
      position: absolute;
      height: 100%;
      width: 10px;
      right: 0;
      top:0;
      box-shadow: 12px 0px 12px 0px rgba(0, 0, 0, 0.12);
    }
      }
      td:first-child,
        td:nth-child(2)  {
        z-index: 1000;
          position: ` + e.theme.components.dataTable.TableBody.tabletView["$isstickycolumn, $showcheckboxenabled"].td.firstChild.position + `;
          left: ` + e.theme.components.dataTable.TableBody.tabletView["$isstickycolumn, $showcheckboxenabled"].td.firstChild.left + `;
           background-color: ` + e.theme.components.dataTable.TableBody.tabletView["$isstickycolumn, $showcheckboxenabled"].td.firstChild.backgroundColor + `;
        }
        td:nth-child(2){
          left: 52px;
        }
        && > tr:nth-child(2n) {
          td:first-child,
          td:nth-child(2)  {
            background-color: ` + e.theme.components.dataTable.TableBody.tabletView["$isstickycolumn, $showcheckboxenabled"]["&& > tr:nth-child(2n)"].td.firstChild.backgroundColor + `;
          }
        }
      ` : `
        td:first-child {
          position: ` + e.theme.components.dataTable.TableBody.tabletView.$isstickycolumn.td.firstChild.position + `;
          left: ` + e.theme.components.dataTable.TableBody.tabletView.$isstickycolumn.td.firstChild.left + `;
            background-color: ` + e.theme.components.dataTable.TableBody.tabletView.$isstickycolumn.td.firstChild.backgroundColor + `;
     &:before {
      content: ' ';
      position: absolute;
      height: 100%;
      width: 10px;
      right: 0;
      top:0;
      box-shadow: 12px 0px 12px 0px rgba(0, 0, 0, 0.12);
    }
  }
        && > tr:nth-child(2n) {
                td:first-child {
                   background-color: ` + e.theme.components.dataTable.TableBody.tabletView.$isstickycolumn["&& > tr:nth-child(2n)"].td.firstChild.even.backgroundColor + `;
                }
        }
        `;
  if (e.$marketingTable)
    return `
        td:nth-child(2n-1):not(:last-child),
        th:nth-child(2n-1):not(:last-child) {
        position: relative;
        left: 0;
    &:before {
      content: ' ';
      position: absolute;
      height: 100%;
      width: 10px;
      right: 0;
      top:0;
      box-shadow: ` + e.theme.components.dataTable.TableBody.marketingBoxShadow + `;
    }
    }
      td:nth-child(2n):not(:last-child),
      th:nth-child(2n):not(:last-child) {
        position: relative;
        left: 0;
    &:before {
      content: ' ';
      position: absolute;
      height: 100%;
      width: 10px;
      right: 0;
      top:0;
      box-shadow: ` + e.theme.components.dataTable.TableBody.marketingBoxShadow + `;
    }
    }
    ` + (e.$isColumnButtonEnabled && `&& > tr:last-child {
          td:nth-child(2n-1) {
        position: relative;
        left: 0;
    &:before {
      content: ' ';
      position: absolute;
      height: 100%;
      width: 10px;
      right: 0;
      top:0;
      box-shadow: 1px 0px 1px 0px transparent;
    }
    }
      td:nth-child(2n):not(:last-child) {
        position: relative;
        left: 0;
    &:before {
      content: ' ';
      position: absolute;
      height: 100%;
      width: 10px;
      right: 0;
      top:0;
      box-shadow: 1px 0px 1px 0px transparent;
    }
    }
    }`) + `
        `;
}, function(e) {
  return `
    width: ` + e.theme.components.dataTable.TableBody.width + `;
    display: ` + e.theme.components.dataTable.TableBody.display + `;
    flex-direction: ` + e.theme.components.dataTable.TableBody.flexDirection + `;
    border-bottom-right-radius: ` + e.theme.components.dataTable.TableBody.borderBottomRightRadius + `;
    border-bottom-left-radius: ` + e.theme.components.dataTable.TableBody.borderBottomLeftRadius + `;
    && > div:nth-child(2n - 1) {
      background-color: ` + e.theme.components.dataTable.TableBody["&& > div:nth-child(2n - 1)"].backgroundColor + `;
    }
    @media ` + d.tabletAndUp + ` {
      display: ` + e.theme.components.dataTable.TableBody.tabletView.display + `;

      && > tr:nth-child(even) {
        background-color: ` + e.theme.components.dataTable.TableBody.tabletView.$isstickycolumn["&& > tr:nth-child(2n)"].td.firstChild.even.backgroundColor + `;

      }
       && > tr:nth-child(odd) {
        background-color: ` + e.theme.components.dataTable.TableBody.tabletView.$isstickycolumn["&& > tr:nth-child(2n)"].td.firstChild.odd.backgroundColor + `;

      }
      ` + (e.$isColumnButtonEnabled && `
      && > tr:last-child {
        background-color: ` + e.theme.components.dataTable.TableBody.tabletView.isColumnButtonEnabled["&& > tr:last-child"].backgroundColor + `;
       td {
          padding-top: ` + e.theme.components.dataTable.TableBody.tabletView.isColumnButtonEnabled["&& > tr:last-child"].td.paddingTop + `;
          padding-bottom: ` + e.theme.components.dataTable.TableBody.tabletView.isColumnButtonEnabled["&& > tr:last-child"].td.paddingBottom + `;
          height: ` + e.theme.components.dataTable.TableBody.tabletView.isColumnButtonEnabled["&& > tr:last-child"].td.height + `;
        }
      }
      `) + `
      
    }
    `;
}), Y = function(t) {
  var a = t.children, l = t.marketingTable, n = t.isColumnButtonEnabled, b = D(t, Q), m = $.useContext(k), T = m.isStickyColumnEnabled, c = m.showCheckboxEnabled;
  return /* @__PURE__ */ o(X, Object.assign({
    $isstickycolumn: T,
    $showcheckboxenabled: c,
    $marketingTable: l,
    $isColumnButtonEnabled: n
  }, b, {
    children: a
  }));
}, G = /* @__PURE__ */ s.td.withConfig({
  displayName: "tData__Data",
  componentId: "gldq2y-0"
})(["", ""], function(e) {
  var t, a, l;
  return `
      display:` + ((t = e.theme.components.dataTable) == null || (t = t.TableData) == null ? void 0 : t.display) + `;
      flex-direction: ` + ((a = e.theme.components.dataTable) == null || (a = a.TableData) == null ? void 0 : a.flexDirection) + `;
      gap: ` + ((l = e.theme.components.dataTable) == null || (l = l.TableData) == null ? void 0 : l.gap) + `;
      @media ` + d.tabletAndUp + ` {
        display: ` + e.theme.components.dataTable.TableData[d.tabletAndUp].display + `;
        height: ` + e.theme.components.dataTable.TableData[d.tabletAndUp].height + `;
        padding: ` + e.theme.components.dataTable.TableData[d.tabletAndUp].padding + `;
        && > div {
          column-gap: ` + e.theme.components.dataTable.TableData[d.tabletAndUp]["div:firstChild"].gap + `;
          
          align-items: ` + e.theme.components.dataTable.TableData[d.tabletAndUp]["div:firstChild"].alignItems[e.$contentAlignment] + `;
        }
      }

    `;
}), E = G, A = /* @__PURE__ */ s.div.withConfig({
  displayName: "tDataContent__TDataContent",
  componentId: "nfry0o-0"
})(["", ""], function(e) {
  return `
    display: ` + e.theme.components.dataTable.TableDataContentContainer.display + `;
      justify-content: ` + (e.$contentAlignment || "left") + `;
      align-items: ` + (e.$contentAlignment || "left") + `;
  flex-direction: ` + e.$flexDirection + `;
    [data-component='checkbox-wrapper'] {
      label {
        padding-bottom: ` + e.theme.components.dataTable.TableDataContentContainer['[data-component="checkbox-wrapper"]'].label.paddingBottom + `;
      }
    };
    `;
}), J = /* @__PURE__ */ s.div.withConfig({
  displayName: "tDataContentWrapper__TDataContentWrapper",
  componentId: "e8qv23-0"
})(["", ""], function(e) {
  return `
      display: flex;
      flex-direction: row;
      justify-content: ` + (e.$contentAlignment || "left") + `;
      align-items: center;
    `;
}), Z = /* @__PURE__ */ s.div.withConfig({
  displayName: "tDataDescription__TDataDescription",
  componentId: "sc-18wa1c7-0"
})(["", ""], function(e) {
  return `
    display: ` + e.theme.components.dataTable.TableDataDescription.display + `;
    justify-content: ` + e.theme.components.dataTable.TableDataDescription.justifyContent + `;
    color: ` + e.theme.components.dataTable.TableDataDescription.color + `;
    font-family: ` + e.theme.components.dataTable.TableDataDescription.fontFamily + `;
    font-size: ` + e.theme.components.dataTable.TableDataDescription.fontSize + `;
    font-style: ` + e.theme.components.dataTable.TableDataDescription.fontStyle + `;
    font-weight: ` + e.theme.components.dataTable.TableDataDescription.fontWeight + `;
    line-height: ` + e.theme.components.dataTable.TableDataDescription.lineHeight + `;
    `;
}), ee = function(t) {
  var a = t.children;
  return /* @__PURE__ */ o(Z, {
    children: a
  });
}, R = /* @__PURE__ */ s.div.withConfig({
  displayName: "tDataTextContent__TableDataTextContainer",
  componentId: "yrbpt0-0"
})(["", ""], function(e) {
  return `
    display: ` + e.theme.components.dataTable.TableDataTextContainer.display + `;
    text-align: ` + e.$contentAlignment + `;
    justify-content: ` + e.$contentAlignment + `;
    align-items: ` + e.theme.components.dataTable.TableDataTextContainer.alignItems + `;
       font-family: ` + e.theme.components.dataTable.TableDataTextContainer.tabletView.fontFamily + `;
      font-size: ` + e.theme.components.dataTable.TableDataTextContainer.tabletView.fontSize + `;
      font-style: ` + e.theme.components.dataTable.TableDataTextContainer.tabletView.fontStyle + `;
      font-weight: ` + e.theme.components.dataTable.TableDataTextContainer.tabletView.fontWeight + `;
      line-height: ` + e.theme.components.dataTable.TableDataTextContainer.tabletView.lineHeight + `;
    color: ` + e.theme.components.dataTable.TableDataTextContainer.color + `;
    .label & {
      color: ` + e.theme.components.dataTable.TableDataTextContainer.label.color + `;
      font-weight: ` + e.theme.components.dataTable.TableDataTextContainer.label.fontWeight + `;
    }

    ` + (e.$marketingTable && e.$marketingTableTitleSize === "small" && `
        display: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.small.display + `;
        font-family: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.small.fontFamily + `;
      font-size: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.small.fontSize + `;
      font-weight: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.small.fontWeight + ` !important;
      line-height: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.small.lineHeight + `;
      color: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.small.color + `;
          width: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.small.width + `;
    overflow-wrap: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.small.overflowWrap + `;
    ` || e.$marketingTable && e.$marketingTableTitleSize === "medium" && `
        display: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.medium.display + `;
        font-family: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.medium.fontFamily + `;
      font-size: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.medium.fontSize + `;
      font-weight: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.medium.fontWeight + ` !important;
      line-height: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.medium.lineHeight + `;]
      color: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.medium.color + `;
      width: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.medium.width + `;
    overflow-wrap: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.medium.overflowWrap + `;
    ` || e.$marketingTable && e.$marketingTableTitleSize === "large" && `
        display: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.large.display + `;
        font-family: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.large.fontFamily + `;
      font-size: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.large.fontSize + `;
      font-weight: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.large.fontWeight + `  !important;
      line-height: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.large.lineHeight + `;
      color: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.large.color + `;  
      width: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.large.width + `;
    overflow-wrap: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.large.overflowWrap + ";") + `
    
    }
      
    }

    @media ` + d.tabletAndUp + ` {
      ` + (e.$marketingTable && e.$marketingTableTitleSize === "small" && `
        font-family: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.small.fontFamily + `;
      font-size: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.small.fontSize + `;
      font-weight: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.small.fontWeight + `;
      line-height: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.small.lineHeight + ";" || e.$marketingTable && e.$marketingTableTitleSize === "medium" && `
        font-family: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.medium.fontFamily + `;
      font-size: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.medium.fontSize + `;
      font-weight: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.medium.fontWeight + `;
      line-height: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.medium.lineHeight + ";" || e.$marketingTable && e.$marketingTableTitleSize === "large" && `
        font-family: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.large.fontFamily + `;
      font-size: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.large.fontSize + `;
      font-weight: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.large.fontWeight + `;
      line-height: ` + e.theme.components.dataTable.TableDataTextContainer.marketingComparisonTable.large.lineHeight + ";") + `
      
    }
    ` + (e.$showAllContent ? `
        overflow: ` + e.theme.components.dataTable.TableDataTextContainer.showAllContent.overflow + `;
        text-overflow: ` + e.theme.components.dataTable.TableDataTextContainer.showAllContent.textOverflow + `;
        display: ` + e.theme.components.dataTable.TableDataTextContainer.showAllContent.display + `;
        -webkit-line-clamp: ` + e.theme.components.dataTable.TableDataTextContainer.showAllContent.WebkitLineClamp + `;
        -webkit-box-orient: ` + e.theme.components.dataTable.TableDataTextContainer.showAllContent.WebkitBoxOrient + `;
        ` : "") + `
    `;
}), te = function(t) {
  var a = t.children, l = t.style, n = t.contentAlignment, b = n === void 0 ? "center" : n, m = t.marketingTable, T = m === void 0 ? !1 : m, c = t.marketingTableTitleSize, i = W(k), C = i.showAllTableDataContent, g = i.setShowAllTableDataContent, w = function() {
    g(!1);
  }, f = function() {
    g(!0);
  };
  return (a == null ? void 0 : a.length) > 40 ? /* @__PURE__ */ o(R, {
    style: l,
    $showAllContent: C,
    onMouseOver: w,
    onMouseOut: f,
    onBlur: f,
    $contentAlignment: b,
    $marketingTable: T,
    $marketingTableTitleSize: c,
    children: a
  }) : /* @__PURE__ */ o(R, {
    $contentAlignment: b,
    $marketingTable: T,
    $marketingTableTitleSize: c,
    children: a
  });
}, ne = ["children", "marketingTable"], ae = /* @__PURE__ */ s.th.withConfig({
  displayName: "th__Th",
  componentId: "l70q24-0"
})(["", ""], function(e) {
  return `
  height: ` + e.theme.components.dataTable.TableHeader.height + `;
  vertical-align: ` + (e.$marketingTable && e.theme.components.dataTable.TableHeader.verticalAlign || "middle") + `;
  padding: ` + (e.$showCheckboxEnabled ? e.theme.components.dataTable.TableHeader.paddingCheckbox : e.theme.components.dataTable.TableHeader.padding) + `;
  align-items: ` + e.theme.components.dataTable.TableHeader.alignItems + `;
  ` + (!e.$marketingTable && `&& > div > div {
    gap: ` + e.theme.components.dataTable.TableHeader.div.gap + `;
    font-family: ` + e.theme.components.dataTable.TableHeader.div.fontFamily + `;
    font-size: ` + e.theme.components.dataTable.TableHeader.div.fontSize + `;
    font-style: ` + e.theme.components.dataTable.TableHeader.div.fontStyle + `;
    font-weight: ` + e.theme.components.dataTable.TableHeader.div.fontWeight + `;
    line-height: ` + e.theme.components.dataTable.TableHeader.div.lineHeight + `;
  }`) + `
  
  text-align: ` + e.theme.components.dataTable.TableHeader.textAlign + `;
  background-color: ` + (!e.$marketingTable && e.theme.components.dataTable.TableHeader.backgroundColor || "transparent") + `;
  @media ` + d.tabletAndUp + ` {
    height: ` + e.theme.components.dataTable.TableHeader.tabletView.height + `;
    padding: ` + e.theme.components.dataTable.TableHeader.tabletView.padding + `;
    && > div {
      gap: ` + e.theme.components.dataTable.TableHeader.tabletView.div[":first-child"].gap + `;
    }
   && > div:last-child {
      ` + (e.$marketingTable && "margin-bottom: " + e.theme.components.dataTable.TableHeader.tabletView.div[":last-child"].marginBottom) + `
    }
  `;
}), z = function(t) {
  var a = t.children, l = t.marketingTable, n = D(t, ne), b = W(k), m = b.showCheckboxEnabled;
  return /* @__PURE__ */ o(ae, Object.assign({
    scope: "col",
    role: "columnheader",
    $showCheckboxEnabled: m,
    $marketingTable: l
  }, n, {
    children: a
  }));
}, _, I, le = U.thead(_ || (_ = N([`
  `, `}
`])), function(e) {
  return `
    display: ` + e.theme.components.dataTable.TableHead.display + `;
    align-items: ` + e.theme.components.dataTable.TableHead.alignItems + `;
    border-bottom: ` + (!e.$marketingTable && e.theme.components.dataTable.TableHead.borderBottom || "unset") + `;
    background-color: ` + (!e.$marketingTable && e.theme.components.dataTable.TableHead.backgroundColor || "transparent !important") + `;
    border-radius: ` + e.theme.components.dataTable.TableHead.borderRadius + `;
    th:nth-child(2) {
      && > div {
        && > div {
          display: ` + e.theme.components.dataTable.TableHead.th.div.firstChild.div.firstChild.display + `;
        }
      }
    }
    @media ` + d.tabletAndUp + ` {
      display: ` + e.theme.components.dataTable.TableHead.tabletView.display + `;
      flex-direction: ` + e.theme.components.dataTable.TableHead.tabletView.flexDirection + `;
      th {
        position: ` + (!e.$marketingTable && e.theme.components.dataTable.TableHead.tabletView.th.position || "unset") + `;
        z-index: ` + e.theme.components.dataTable.TableHead.tabletView.th.zIndex + `;
        top: ` + e.theme.components.dataTable.TableHead.tabletView.th.top + `;
      }
      ` + (e.$isstickycolumn && e.$showcheckboxenabled ? `
          th:nth-child(2) {
            &:before {
      content: ' ';
      position: absolute;
      height: 100%;
      width: 10px;
      right: 0;
      top:0;
      box-shadow: 12px 0px 12px 0px rgba(0, 0, 0, 0.12);
    }
          }
          th:first-child,
          th:nth-child(2)  {
            position: ` + e.theme.components.dataTable.TableHead.tabletView["$isstickycolumn $showcheckboxenabled"].firstChild.position + `;
            left: ` + e.theme.components.dataTable.TableHead.tabletView["$isstickycolumn $showcheckboxenabled"].firstChild.left + `;
            z-index: ` + e.theme.components.dataTable.TableHead.tabletView["$isstickycolumn $showcheckboxenabled"].firstChild.zIndex + `;
          }
          th:nth-child(2){
            left: ` + e.theme.components.dataTable.TableHead.tabletView["$isstickycolumn $showcheckboxenabled"]["nthChild: 2"].left + `;
          }
          ` : "") + `
        ` + (e.$isstickycolumn ? `
          th:first-child {
            position: ` + e.theme.components.dataTable.TableHead.tabletView.$isstickycolumn.firstChild.position + `;
            left: ` + e.theme.components.dataTable.TableHead.tabletView.$isstickycolumn.firstChild.left + `;
            z-index: ` + e.theme.components.dataTable.TableHead.tabletView.$isstickycolumn.firstChild.zIndex + `;
            &:before {
      content: ' ';
      position: absolute;
      height: 100%;
      width: 10px;
      right: 0;
      top:0;
      box-shadow: 12px 0px 12px 0px rgba(0, 0, 0, 0.12);
    }
          }
          ` : "") + `
    }
    `;
}), oe = U.tr(I || (I = N([`
  &.TableHeadTR {
    `, `;
  }
`])), function(e) {
  var t = e.theme.components.dataTable;
  return L(t.TableHeadTR);
}), ie = function(t) {
  var a = t.children, l = t.$checkboxProps, n = t.marketingTable, b = t.rowIds, m = P(0), T = m[0], c = m[1], i = $.useContext(k), C = i.checkboxCheckedValues, g = i.setAllCheckboxChecked, w = i.showOptionsEnabled, f = i.showCheckboxEnabled, u = i.isStickyColumnEnabled, x = i.rowIds, V = q(), p = V.width;
  return K(function() {
    var y = C.filter(function(r) {
      return (x == null ? void 0 : x.includes(r.id)) && !r.disabled;
    }).some(function(r) {
      return r.value === v.UNCHECKED;
    });
    if (y) {
      c(0);
      return;
    }
    if (C.length) {
      var H = C.filter(function(r) {
        return (x == null ? void 0 : x.includes(r.id)) && !r.disabled;
      }).every(function(r) {
        return r.value === v.CHECKED;
      });
      if (H) {
        c(2);
        return;
      }
    }
  }, [C, x]), /* @__PURE__ */ o(le, {
    $showcheckboxenabled: f,
    $isstickycolumn: u,
    $marketingTable: n,
    children: /* @__PURE__ */ j(oe, {
      className: "TableHeadTR",
      children: [f && /* @__PURE__ */ o(z, {
        marketingTable: n,
        style: {
          padding: p >= S.tabletMin ? "3px 16px 4px" : "12px 16px 4px"
        },
        children: /* @__PURE__ */ o(A, {
          children: /* @__PURE__ */ o(O, {
            checkboxValue: T,
            disabled: l == null ? void 0 : l.disabled,
            onChange: function(H, r) {
              var B = r ? v.CHECKED : v.UNCHECKED;
              c(B), g && g(B, void 0, b), l && l.onClick && l.onClick(H, B);
            }
          })
        })
      }), a, w && p >= S.tabletMin && /* @__PURE__ */ o(z, {
        marketingTable: n,
        children: /* @__PURE__ */ o(A, {})
      })]
    })
  });
}, de = ["children", "$checkboxProps", "id", "$dropDownComponent", "contentAlignment"], be = /* @__PURE__ */ s.tr.withConfig({
  displayName: "tRow__TableRow",
  componentId: "sc-1ishx5b-0"
})(["", ""], function(e) {
  return `
    display: ` + e.theme.components.dataTable.TableRow.display + `;
    border-radius: ` + e.theme.components.dataTable.TableRow.borderRadius + `;
    @media ` + d.tabletAndUp + ` {
      display: ` + e.theme.components.dataTable.TableRow.tabletView.display + `;
      td:not(:first-child) {
        && > div:only-child {
          color: ` + e.theme.components.dataTable.TableRow.tabletView["td:not(:first-child)"]["div:first-child:only-child"].color + `;
        }
      }
    }
    width: ` + e.theme.components.dataTable.TableRow.width + `;
    `;
}), me = function(t) {
  var a, l = t.children, n = t.$checkboxProps, b = t.id, m = t.$dropDownComponent, T = t.contentAlignment, c = T === void 0 ? "center" : T;
  D(t, de);
  var i = $.useContext(k), C = i.checkboxCheckedValues, g = i.setCheckboxChecked, w = i.showOptionsEnabled, f = i.showCheckboxEnabled, u = C == null ? void 0 : C.find(function(x) {
    return x.id === b;
  });
  return /* @__PURE__ */ j(be, {
    role: "row",
    children: [f && /* @__PURE__ */ o(E, {
      $contentAlignment: c,
      children: /* @__PURE__ */ o(h.CellContent, {
        style: {
          paddingBottom: "0px"
        },
        children: /* @__PURE__ */ o(O, {
          checkboxValue: (a = n == null ? void 0 : n.checkboxDefaultValue) != null ? a : u == null ? void 0 : u.value,
          disabled: (n == null ? void 0 : n.disabled) || (u == null ? void 0 : u.disabled),
          onChange: function(V, p) {
            var y = p;
            g && g(b, y), n && n.onClick && n.onClick(V, b, y, !!(n != null && n.disabled));
          }
        })
      })
    }), l, w && /* @__PURE__ */ o(E, {
      $contentAlignment: c,
      children: /* @__PURE__ */ o(h.CellContent, {
        children: m
      })
    })]
  });
}, ce = /* @__PURE__ */ $.memo(me), he = ["children", "style", "isMarketingTable", "isEmpty"], M = /* @__PURE__ */ s.div.withConfig({
  displayName: "tableV1__TableContainer",
  componentId: "sc-1u8ldjp-0"
})(["", ""], function(e) {
  return `
    border: ` + e.theme.components.dataTable.TableV1.TableContainer.border + `;
    border-radius: ` + e.theme.components.dataTable.TableV1.TableContainer.borderRadius + `;
    width: ` + e.theme.components.dataTable.TableV1.TableContainer.width + `;
    overflow-y: ` + e.theme.components.dataTable.TableV1.TableContainer.overflowY + `;
    @media ` + d.tabletAndUp + ` {
      overflow-x: ` + e.theme.components.dataTable.TableV1.TableContainer.tabletView.overflowX + `;
      position: ` + e.theme.components.dataTable.TableV1.TableContainer.tabletView.position + `;
      justify-content: ` + e.theme.components.dataTable.TableV1.TableContainer.tabletView.justifyContent + `;
      align-items: ` + e.theme.components.dataTable.TableV1.TableContainer.tabletView.alignItems + `;
    }
    `;
}), Te = /* @__PURE__ */ s.table.withConfig({
  displayName: "tableV1__TableComponent",
  componentId: "sc-1u8ldjp-1"
})(["", ""], function(e) {
  return `    
    table-layout: ` + (e.$isMarketingTable && "fixed" || "unset") + `;
    background:` + (!e.$isMarketingTable && e.theme.components.dataTable.TableV1.TableComponent.background) + `;
    height: ` + (e.$isEmpty ? e.theme.components.dataTable.TableV1.TableComponent.height : "unset") + `;
    display: ` + e.theme.components.dataTable.TableV1.TableComponent.display + `;
    flex-direction: ` + e.theme.components.dataTable.TableV1.TableComponent.flexDirection + `;
    width: ` + e.theme.components.dataTable.TableV1.TableComponent.width + `;
    thead {
      position: ` + (!e.$isMarketingTable && e.theme.components.dataTable.TableV1.TableComponent.thead.position || "unset") + `;
      z-index: ` + e.theme.components.dataTable.TableV1.TableComponent.thead.zIndex + `;
      top: ` + e.theme.components.dataTable.TableV1.TableComponent.thead.top + `;
    }
    @media ` + d.mobile + ` {
      ` + (e.$showCheckboxEnabled ? `
      th:not(:nth-child(2)) {
        display: ` + e.theme.components.dataTable.TableV1.TableComponent.mobileView.checkboxEnabled.th.display + `;
      }
      ` : `
      th:not(:nth-child(1)) {
        display: ` + e.theme.components.dataTable.TableV1.TableComponent.mobileView.checkboxDisabled.th.display + `;
      }
      `) + `
    }
    @media ` + d.tabletAndUp + ` {
      display: ` + e.theme.components.dataTable.TableV1.TableComponent.tabletView.display + `;
      flex-direction: ` + e.theme.components.dataTable.TableV1.TableComponent.tabletView.flexDirection + `;
      border-collapse: ` + e.theme.components.dataTable.TableV1.TableComponent.tabletView.borderCollapse + `;
      ` + (e.$showCheckboxEnabled ? `
      th:not(:nth-child(2)) {
        display: ` + e.theme.components.dataTable.TableV1.TableComponent.tabletView.checkboxEnabled.th.display + `;
      }
      ` : `
      th:not(:nth-child(1)) {
        display: ` + e.theme.components.dataTable.TableV1.TableComponent.tabletView.checkboxDisabled.th.display + `;
      }
      `) + `
    }
    `;
}), h = function(t) {
  var a = t.children, l = t.style, n = t.isMarketingTable, b = n === void 0 ? !1 : n, m = t.isEmpty, T = D(t, he), c = F.useContext(k), i = c.showCheckboxEnabled;
  return /* @__PURE__ */ o(M, {
    style: l,
    children: /* @__PURE__ */ o(Te, Object.assign({}, T, {
      $isEmpty: m,
      $showCheckboxEnabled: i,
      $isMarketingTable: b,
      children: a
    }))
  });
};
h.Head = ie;
h.Header = z;
h.Body = Y;
h.Row = ce;
h.Cell = E;
h.CellWrapper = J;
h.CellContent = A;
h.CellContentText = te;
h.CellDescription = ee;
h.Container = M;
export {
  h as T,
  ie as a
};
